import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'recompose';

import { Button, Icon } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './TermsAndConditionsDeclineModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const TermsAndConditionsDeclineModal = ({
  intl,
  onOk,
  onCancel,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <FormattedMessage
        id="TermsOfService.DeclineConfirmationDialog.title"
        defaultMessage="** Are you sure you want to decline?"
      />
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.body }>
      <FormattedMessage
        id="TermsOfService.DeclineConfirmationDialog.body"
        defaultMessage="** In order to use the app you must agree to the terms and conditions. Choosing decline will log you off the system."
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-tos-decline-button"
        buttonType="naked"
        label={ intl.formatMessage({ id: 'TermsOfService.DeclineConfirmationDialog.cancelBtn', defaultMessage: '** Cancel' }) }
        className={ theme.cancelButton }
        labelColor="blackMedium"
        onClick={ onCancel }
      />

      <Button
        testId="modal-tos-button"
        label={ intl.formatMessage({ id: 'TermsOfService.DeclineConfirmationDialog.declineBtn', defaultMessage: '** Yes, decline' }) }
        background="red"
        onClick={ onOk }
      />
    </div>
  </div>
);

TermsAndConditionsDeclineModal.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(TermsAndConditionsDeclineModal);
